"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyFrequencyGroupStatsToJSON = exports.SurveyFrequencyGroupStatsFromJSONTyped = exports.SurveyFrequencyGroupStatsFromJSON = exports.instanceOfSurveyFrequencyGroupStats = void 0;
var runtime_1 = require("../runtime");
var SurveyGroupStats_1 = require("./SurveyGroupStats");
/**
 * Check if a given object implements the SurveyFrequencyGroupStats interface.
 */
function instanceOfSurveyFrequencyGroupStats(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfSurveyFrequencyGroupStats = instanceOfSurveyFrequencyGroupStats;
function SurveyFrequencyGroupStatsFromJSON(json) {
    return SurveyFrequencyGroupStatsFromJSONTyped(json, false);
}
exports.SurveyFrequencyGroupStatsFromJSON = SurveyFrequencyGroupStatsFromJSON;
function SurveyFrequencyGroupStatsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'frequencyRange': !(0, runtime_1.exists)(json, 'frequency_range') ? undefined : json['frequency_range'],
        'stats': !(0, runtime_1.exists)(json, 'stats') ? undefined : (0, SurveyGroupStats_1.SurveyGroupStatsFromJSON)(json['stats']),
    };
}
exports.SurveyFrequencyGroupStatsFromJSONTyped = SurveyFrequencyGroupStatsFromJSONTyped;
function SurveyFrequencyGroupStatsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'frequency_range': value.frequencyRange,
        'stats': (0, SurveyGroupStats_1.SurveyGroupStatsToJSON)(value.stats),
    };
}
exports.SurveyFrequencyGroupStatsToJSON = SurveyFrequencyGroupStatsToJSON;
